export enum Strings {
    UID = 'uid',
    TABS = '/mobile',
    LOGIN = '/login',
    ADMIN = '/admin',
    TYPE = 'user'
}
